export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    avatarUrl() {
      return this.item.causer.attributes.large_avatar_url
    },
    name() {
      return `${this.item.causer.attributes.first_name} ${this.item.causer.attributes.last_name}`
    },
    date() {
      return this.moment(this.item.attributes.created_at).fromNow()
    },
  },
}